var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('AllSmsCard',{attrs:{"data":_vm.texts}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }